export default __webpack_public_path__ + "static/media/undraw_calendar.4f2684e5.svg";